import { QueryClient } from '@tanstack/react-query';

// Defaults per 03-Planning.md PR-05:
//   • staleTime 30s — saves a refetch on quick navigation back to a page.
//   • failures stay settled until the user retries or a mutation invalidates.
//   • disable refetchOnWindowFocus — feels noisy for a content-heavy app.
export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
        retryOnMount: false,
        retry: false,
      },
      mutations: {
        retry: false,
      },
    },
  });
}
